import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { SubscriptionFrequencyInfo } from 'autogen/swagger/all';
import { CustomInterval } from 'autogen/translation-keys/trans-website-product-subscription';
import { SelectedFrequencyContext } from 'components/pages/PDP/components/MidSection/hooks/context';
import Select from 'components/shared/inputs/select/Select';
import { getFrequencyFromId, getSelectedGroup, getShortListOptions, mapOptionsData } from './shared/helpers';

const customIntervalValue = 'customInterval';

const StyledSelect = styled(Select)`
    width: 100%;
`;

export default function SimpleSelection({
    subscriptionFrequencyInfo,
    toggleAdvanceCallback
}: {
    subscriptionFrequencyInfo: SubscriptionFrequencyInfo;
    toggleAdvanceCallback: () => void;
}): JSX.Element {
    const { choosable } = subscriptionFrequencyInfo;
    const { t } = useTranslation();
    const { selectedFrequency, setSelectedFrequency } = useContext(SelectedFrequencyContext);
    const selectedGroup = getSelectedGroup(choosable);
    const shortListOptions = getShortListOptions(selectedGroup.frequencies);
    const formattedFrequencies = mapOptionsData(shortListOptions);

    formattedFrequencies.push({ label: t(CustomInterval), value: customIntervalValue });

    return (
        <StyledSelect
            onChange={(newFrequency) => {
                if (newFrequency.value === customIntervalValue) {
                    toggleAdvanceCallback();
                } else {
                    const frequency = getFrequencyFromId(shortListOptions, newFrequency.value);

                    setSelectedFrequency(frequency);
                }
            }}
            options={formattedFrequencies}
            value={{ label: selectedFrequency.nameWithRecommendationText, value: selectedFrequency.id.toString() }}
        />
    );
}
